module.exports = __webpack_public_path__ + "static/chicken-tinder-mac-3b547af86cafbae29792d5d0448b7b1f.png";